import React, { FC, useEffect, useMemo } from 'react'

import useBackgroundService from '@web/hooks/useBackgroundService'
import useContractNamesControllerState from '@web/hooks/useContractNamesController/useContractNamesController'

import { ContractNameChildren } from './types'

/**
 * Extension build: the ContractNamesController lives in the background service
 * worker, so the name is requested through the messengers and read back from
 * the mirrored state.
 */
const ExtensionContractName: FC<{
  address: string
  chainId: bigint
  children: ContractNameChildren
}> = ({ address, chainId, children }) => {
  const { contractNames } = useContractNamesControllerState()
  const { dispatch } = useBackgroundService()

  const name = useMemo(() => contractNames[address]?.name || undefined, [contractNames, address])

  useEffect(() => {
    if (name) return

    dispatch({ type: 'CONTRACT_NAMES_CONTROLLER_GET_NAME', params: { address, chainId } })
  }, [dispatch, address, chainId, name])

  return <>{children(name)}</>
}

export default ExtensionContractName
